module.exports = __webpack_public_path__ + "static/media/more.95ba50a4.svg";